<div class="painel-lateral-layout" [class.painel-lateral-layout--sem-filtros]="ocultarFiltros()">
    @if (!ocultarFiltros()) {
        <aside class="coluna-filtros">
            <app-card-content [title]="tituloPainel()" [subtitle]="descricaoPainel()" [icon]="iconePainel()" [border]="false" headingLevel="h1">
                @if (filtrosTemplate()) {
                    <div class="filtros-painel">
                        <ng-container [ngTemplateOutlet]="filtrosTemplate()!"></ng-container>
                    </div>
                }
            </app-card-content>
        </aside>
    }

    <section class="coluna-conteudo">
        <ng-container [ngTemplateOutlet]="conteudoTemplate()"></ng-container>
    </section>
</div>
